import { NavigateFunction } from "react-router-dom";
import { AuthApiService } from "../service/authService";

export const validateTokenAndLogoutIfExpired = async (
  navigate: NavigateFunction
) => {
  try {
    const res = await AuthApiService.fetchIdTokenFromCognitoSession();
    const token = res;

    if (isTokenExpired(token)) {
      AuthApiService.logout();
      navigate(`/`);
      return null;
    }
    return token;
  } catch (error) {
    console.error("Error fetching token: ", error);
    navigate(`/`);
    return null;
  }
};

export const matchUserRoleWithCurrentPath = (
  currentPath: string,
  navigate: NavigateFunction
) => {
  const userRole = getUserRoleFromLocalStorage();
  const currentPathRole = currentPath.split("/")[1];
  if (userRole && currentPathRole === userRole) {
    return true;
  }
  navigate(`/`);
  AuthApiService.logout();
  return false;
};

export const getUserRoleFromLocalStorage = () => {
  const allKeys = Object.keys(localStorage);
  let userRoleKey = "";
  allKeys.forEach((key) => {
    if (key.includes("userRole")) {
      userRoleKey = key;
    }
  });
  return localStorage.getItem(userRoleKey);
};

const isTokenExpired = (token: any) => {
  const decodedToken = decodeToken(token);
  return decodedToken.exp * 1000 < Date.now(); // Check token expiration
};

const decodeToken = (token: any) => {
  const payload = token.split(".")[1];
  return JSON.parse(atob(payload)); // Decode JWT token
};
